// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M15.4142 1H3V23H11.5V17C11.5 13.4101 14.4101 10.5 18 10.5C19.0821 10.5 20.1025 10.7644 21 11.2322V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M18.001 14.5C18.6913 14.5 19.251 15.0596 19.251 15.75V16.5H16.751V15.75C16.751 15.0596 17.3106 14.5 18.001 14.5ZM21.251 16.5V15.75C21.251 13.9551 19.7959 12.5 18.001 12.5C16.2061 12.5 14.751 13.9551 14.751 15.75V16.5H13.5V23H22.5V16.5H21.251Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-file-locked-filled')
export default class FileLockedFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-locked-filled',
    }
  }
}
